import styled from 'styled-components';
import { colors } from '../../../stylesheets';

const AccordionWrapper = styled.div`
  transition: all 0.3s;
  min-height: ${(props) => (props.show ? 1 : 0)}px;
  border-bottom: 1px solid ${colors.lighterGray};
`;

export default AccordionWrapper;
